import NextLink from 'next/link'

import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'
import { Link } from '@wartek-id/link'

import type { FC } from 'react'

interface HeaderBadgeProps extends BadgeProps {
  label: string
  href: string
}

const HeaderBadge: FC<HeaderBadgeProps> = ({ label, href, ...props }) => {
  if (!!label)
    return (
      <NextLink href={href} passHref>
        <Link className="!no-underline !p-0 focus:!outline-none focus:!border-none focus:!shadow-none">
          <Badge variant="neutral" {...props}>
            {label}
          </Badge>
        </Link>
      </NextLink>
    )

  return null
}
export default HeaderBadge
